<template>
  <div class="shop-costbreakdown">
    <PropertyChanges v-if="parts.includes('referencePropertyChanges')" />
    <hr />
    <template v-if="parts.includes('category')"
      ><div
        v-for="(category, index) in categories"
        :key="index"
        class="shop-costbreakdown__row"
        data-part="category"
      >
        <div class="shop-costbreakdown__cell">{{ category.label }}</div>
        <div class="shop-costbreakdown__cell">{{ Currency(category.total) }}</div>
      </div></template
    >
    <hr />
    <div
      v-if="parts.includes('unit') && unit.total"
      class="shop-costbreakdown__row"
      data-part="unit"
    >
      <div class="shop-costbreakdown__cell">{{ unit.label }}</div>
      <div class="shop-costbreakdown__cell">{{ Currency(unit.total) }}</div>
    </div>
    <div
      v-if="parts.includes('shop') && unit.total"
      class="shop-costbreakdown__row"
      data-part="shop"
    >
      <div class="shop-costbreakdown__cell">{{ $t('shopShort') }}</div>
      <div class="shop-costbreakdown__cell">{{ Currency(shopTotal) }}</div>
    </div>
    <hr />
    <div v-if="parts.includes('total')" class="shop-costbreakdown__row" data-part="total">
      <div class="shop-costbreakdown__cell">{{ $t('total') }}</div>
      <div class="shop-costbreakdown__cell">
        {{ Currency(total) }}
        <template v-if="disclaimer">*</template>
      </div>
    </div>
    <div v-if="disclaimer" class="shop-costbreakdown__row" data-part="disclaimer">
      <div class="shop-costbreakdown__cell">* {{ disclaimer }}</div>
    </div>
  </div>
</template>

<script>
import { getCategoryTotal, CheckConditions, Currency } from '../utils'
import PropertyChanges from '../components/PropertyChanges'

export default {
  props: {
    parts: {
      type: Array,
      default: () => ['category', 'unit', 'shop', 'referencePropertyChanges', 'total'],
    },
    shop: Object,
  },
  computed: {
    unit() {
      return {
        label: this.shop.reference.name,
        total: parseInt(
          this.$route.query.unit ||
            this.$path('shop.reference.sale.value') ||
            this.$path('shop.reference.price') ||
            0,
        ),
      }
    },
    disclaimer() {
      return this.$route.query.disclaimer
    },
    categories() {
      return this.shop.categories
        .filter(category => CheckConditions(category, this.shop))
        .map(category => ({
          label: category.label,
          total: getCategoryTotal(category.id, this.shop),
        }))
        .filter(({ total }) => total)
    },
    shopTotal() {
      return this.categories.reduce((sum, { total }) => sum + total, 0)
    },
    total() {
      return this.shopTotal + this.unit.total
    },
  },
  methods: {
    Currency(value) {
      return new Intl.NumberFormat('nb-NO', {
        style: 'currency',
        currency: this.shop.metadata.currency,
        currencyDisplay: 'narrowSymbol',
        trailingZeroDisplay: 'stripIfInteger',
      }).format(value)
    },
  },
  components: {
    PropertyChanges,
  },
}
</script>

<style lang="scss">
@import '../mixins.scss';

.shop-costbreakdown {
  --spacing: 0.25rem;

  display: grid;
  grid-template-columns: 1fr auto;

  @include onPhone {
    font-size: 0.8em;
  }

  .shop-property-changes {
    grid-column: 1 / -1;
  }

  &__row {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;

    padding-block: var(--spacing);

    &--zero {
      display: none;
    }

    & > *:last-child {
      text-align: end;
      justify-content: flex-end;
    }

    &:first-child {
      padding-block-start: 0;
    }
    &:last-child {
      padding-block-end: 0;
    }
  }

  &__cell {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    &:first-child {
      flex-grow: 1;
    }
  }

  [data-part='total'] {
    font-size: 1.25rem;
    font-weight: bold;
  }

  [data-part='disclaimer'] {
    font-size: 0.8em;
    opacity: 0.8;

    & > *:first-child:last-child {
      grid-column: 1 / -1;
    }
  }

  hr {
    width: 100%;
    grid-column: 1 / -1;
    margin-block: calc(var(--spacing) * 2);

    border-color: var(--border-color);

    &:first-child,
    &:last-child,
    & + hr {
      display: none;
    }
  }

  h3 {
    margin-block-start: 0;
    margin-block-end: calc(var(--spacing) * 2);
    grid-column: 1 / -1;
    font-size: 1.25rem;
  }
}
</style>
